<template>
  <div class="col-24 col-lg d-flex" @click.stop.prevent="setPayment">
    <slot />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      childClasses: null,
    };
  },
  computed: {
    ...mapGetters({
      activePayment: "checkoutPayment/getActivePayment",
    }),
  },
  watch: {
    activePayment() {
      this.setButtonBorder();
    },
  },
  mounted() {
    this.childClasses = this.$el.children[0].classList;
    this.setButtonBorder();
  },
  methods: {
    setButtonBorder() {
      this.childClasses.remove("border-secondary");
      if (this.activePayment === this.id) {
        this.childClasses.add("border-secondary");
      }
    },
    ...mapActions({
      setActivePayment: "checkoutPayment/setActivePayment",
    }),
    setPayment() {
      this.setActivePayment(this.id);
    },
  },
};
</script>
